module.exports = __webpack_public_path__ + "media/metronic/_theme/media/blog/blog4-06a2793060943b9eb1b9e7a9e4ddb977.jpg";